import styled, { css } from 'styled-components'

const Main = styled.main`
  ${({ theme }) => css`
    max-width: 80rem;
    margin: 0 auto;
    padding: ${theme.spacing(2)};

    ${theme.media('sm')} {
      padding: ${theme.spacing(5)};
    }

    p,
    a,
    li {
      font-size: 1.8rem;
    }

    li + li,
    li > ul {
      margin-top: ${theme.spacing(1)};
    }

    a {
      overflow-wrap: anywhere;
    }

    h1 {
      padding-bottom: ${theme.spacing(4)};
      text-align: center;
      border-bottom: 0.1rem solid ${theme.palette.grey[300]};
    }

    table {
      border-collapse: collapse;

      th {
        text-align: left;
      }

      th,
      td {
        padding: ${theme.spacing(1)} ${theme.spacing(2)};
        border-top: 0.1rem solid ${theme.palette.grey[300]};
        border-right: 0.1rem solid ${theme.palette.grey[300]};

        &:first-child {
          border-left: 0.1rem solid ${theme.palette.grey[300]};
        }
      }

      tr:last-child {
        td {
          border-bottom: 0.1rem solid ${theme.palette.grey[300]};
        }
      }
    }
  `}
`

export default {
  Main,
}
